import { useAuthStore } from '@/store/auth-store';
import { sessionScope, sessionRevision } from '@/features/auth/session-scope';

// Lightweight enough for the realtime entry; SDK/read implementations stay lazy.
export const crmListKey = (scope = sessionScope(useAuthStore.getState())) =>
  ['contacts', 'crm', scope] as const;
export const crmContactKey = (
  id?: string,
  kind = 'detail',
  scope = sessionScope(useAuthStore.getState()),
) => ['contact', id ?? null, kind, scope] as const;
export function isCurrentCRMContactKey(
  key: readonly unknown[],
  scope = sessionScope(useAuthStore.getState()),
) {
  return (
    key[0] === 'contact' &&
    key[3] === scope &&
    ['detail', 'stats', 'conversations', 'merged', 'pipeline-status', 'tags'].includes(
      String(key[2]),
    )
  );
}

// Compatible prefix for shared Kanban hints; full Kanban consumers will migrate
// to checked/scoped keys in their own module pass.
export const contactPipelineKey = (kind: string, id?: string, scope = sessionScope(useAuthStore.getState())) =>
  ['kanban', kind, id ?? null, 'crm', scope] as const;
export const isCurrentContactPipelineKey = (key: readonly unknown[]) =>
  key[0] === 'kanban' && key[3] === 'crm' && key[4] === sessionScope(useAuthStore.getState());
export function isCurrentKanbanKey(key: readonly unknown[], kind?: string, id?: string, scope = sessionScope(useAuthStore.getState())) {
  return key[0] === 'kanban' && (!kind || key[1] === kind) && (!id || key[2] === id) &&
    (key[3] === 'board' ? key[4] === scope && key[5] === sessionRevision() : key[3] !== 'crm' || key[4] === scope);
}
